export default "__VITE_ASSET__62711c4c__"